import { merge } from 'lodash'

export default function (existingModel = {}) {
  return {
    model: merge(
      {
        addressLine1: null,
        addressLine2: null,
        addressLocality: null,
        addressRegion: null,
        addressCode: null,
        addressCountry: null,
        addressCoordinates: []
      },
      existingModel
    ),
    validation: {
      fullAddress: { required: true }
    }
  }
}
